'use client'

import { useState, useEffect } from 'react'
import axios from 'axios';
import Navbar from '../../components/landing/navbar'
import CarouselSlide from './carouselSlide';
import Footer from '../../components/footer';
import ProductList from '../../components/productList';

// function classNames(...classes) {
//   return classes.filter(Boolean).join(' ')
// }

const apiurl = `${process.env.REACT_APP_API}`
// const imgurl = `${process.env.REACT_APP_URL}/image/products`

export default function Shop() {
  const [promot, setPromote] = useState(null);

  useEffect(() => {
    const fetchPromote = async () => {
      try {
        const result = await axios.get(`${apiurl}/products.php?mode=getpromote`);
        
        // console.log(result);
        if(result.data && result.data[0].length>0) {  
          setPromote(result.data[0]);
          return result.data[0];
        } //else {
         // setPromote(promote);
       // }
      }
      catch(err) {
          console.log(err);
        }
      }
  
      fetchPromote();
    
  },[]); 
  
  // console.log(page);

  return (
    <div className="w-full min-w-96 bg-gradient-to-br from-slate-900 from-10% via-slate-700 via-45% to-slate-800 to-85%" >
      <div className="flex justify-center h-16">
        <Navbar />
      </div>
      <div id="sector1" className="px-6">
        <div className="flex items-center justify-center rounded-xl max-w-7xl p-0 mt-4 xl:mt-8 mx-auto bg-cover bg-center" style={{backgroundImage: 'url(/special-recipe.jpg)'}}>
          {promot && (
            <div className="w-full max-w-7xl mx-auto p-2 text-slate-400 rounded-xl">
                    <CarouselSlide slides={promot} autoSlide={true} autoSlideInterval={5000} />
            </div>
          )}
        </div>
      </div>

      <ProductList />
      
      <div className="mx-auto max-w-7xl justify-center">
        <Footer />
      </div>
    </div>

  )
}
